/* VisitorsTillNow — honest all-time unique visitor counter, shown above Reviews. */
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Users } from 'lucide-react';
import { trackVisitorOnce } from '../lib/visitorTrack';

const API = process.env.REACT_APP_BACKEND_URL;

export const VisitorsTillNow = () => {
  const [total, setTotal] = useState(null);
  const [failed, setFailed] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    let alive = true;
    const readCount = async () => {
      try {
        const { data } = await axios.get(`${API}/api/visitor-count`, { params: { format: 'json' } });
        if (alive && typeof data.totalVisitors === 'number') {
          setTotal(data.totalVisitors);
          setFailed(false);
        }
      } catch {
        if (alive && total === null) setFailed(true);
      }
    };
    const start = async () => {
      const tracked = await trackVisitorOnce();
      if (alive && typeof tracked === 'number') {
        setTotal(tracked);
        setFailed(false);
      } else {
        await readCount();
      }
      timerRef.current = setInterval(readCount, 60000);
    };
    start();
    return () => { alive = false; clearInterval(timerRef.current); };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <section className="bg-white py-12 md:py-16 px-4" aria-label="Visitor counter" data-testid="visitors-till-now-section">
      <div className="max-w-xl mx-auto">
        <div className="rounded-3xl border border-teal-100 bg-gradient-to-br from-teal-50 via-white to-emerald-50 shadow-sm px-6 py-8 md:py-10 text-center">
          <p className="text-xs font-black uppercase tracking-[0.25em] text-teal-600 mb-3 flex items-center justify-center gap-2">
            <Users size={14} aria-hidden="true" /> Our Growing Community
          </p>
          {failed && total === null ? (
            <p className="text-sm text-gray-500" data-testid="visitors-count-error">
              Visitor count temporarily unavailable
            </p>
          ) : total === null ? (
            <div className="h-12 md:h-14 w-40 mx-auto rounded-xl bg-gray-100 animate-pulse" data-testid="visitors-count-skeleton" aria-hidden="true" />
          ) : (
            <p
              className="text-4xl md:text-5xl font-black text-gray-900 tabular-nums transition-opacity duration-500"
              data-testid="visitors-count-value"
            >
              {total.toLocaleString('en-IN')}
            </p>
          )}
          <p className="text-sm font-bold text-gray-500 mt-2" data-testid="visitors-count-caption">Visitors Till Now</p>
        </div>
      </div>
    </section>
  );
};

export default VisitorsTillNow;
